import createIcon from '../../createIcon';

/**
 * @component @name CropRotate
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8yMzczMikiPgo8cGF0aCBkPSJNNy40NyAyMS40OUM0LjIgMTkuOTMgMS44NiAxNi43NiAxLjUgMTNIMEMwLjUxIDE5LjE2IDUuNjYgMjQgMTEuOTUgMjRDMTIuMTggMjQgMTIuMzkgMjMuOTggMTIuNjEgMjMuOTdMOC44IDIwLjE1TDcuNDcgMjEuNDlaTTEyLjA1IDBDMTEuODIgMCAxMS42MSAwLjAyIDExLjM5IDAuMDRMMTUuMiAzLjg1TDE2LjUzIDIuNTJDMTkuOCA0LjA3IDIyLjE0IDcuMjQgMjIuNSAxMUgyNEMyMy40OSA0Ljg0IDE4LjM0IDAgMTIuMDUgMFpNMTYgMTRIMThWOEMxOCA2Ljg5IDE3LjEgNiAxNiA2SDEwVjhIMTZWMTRaTTggMTZWNEg2VjZINFY4SDZWMTZDNiAxNy4xIDYuODkgMTggOCAxOEgxNlYyMEgxOFYxOEgyMFYxNkg4WiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNDAyXzIzNzMyIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CropRotate = createIcon('CropRotate', [
  ['g', { clipPath: 'url(#clip0_2402_23732)', key: '1l9gpl' }],
  ['defs', { key: '9ahrjx' }],
]);

export default CropRotate;
